module.exports = __webpack_public_path__ + "img/estrela.3c76e64c.svg";